import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Common/Configurations/AuthContext";
import AirlineOffers from "../../../Components/Advertisements/AirlineOffers";
import SearchFlightPanel2 from "../SearchFlightPanel/SearchFlightPanel2";

const SearchFlight2 = ({ mode, onNavigate, templateId, branding, styleConfig }) => { // 👈 Added styleConfig
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [currency, setCurrency] = useState(user?.currency);

  // 👇 1. DYNAMIC THEME VARIABLES
  const themeVariables = {
    "--primary-color": styleConfig?.primary || "#0b2b44",
    "--secondary-color": styleConfig?.secondary || "#1f3b5c",
    "--border-color": "#dae6f5"
  };

  const handleCurrencyChange = (newCurrency) => {
    setCurrency(newCurrency);
  };

  if (loading) return <div style={{padding: '50px', textAlign: 'center', color: '#fff'}}>Loading...</div>;


  return (
    // 👇 2. INJECT CSS VARIABLES HERE
    <div id="layout-wrapper" style={themeVariables}>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            
            {/* Search Panel Component */}
            <SearchFlightPanel2 
              mode={mode} 
              onNavigate={onNavigate} 
              templateId={templateId}
              styleConfig={styleConfig} // 👈 Pass it down just in case the panel needs direct access
            />
           
            {/* Advertisements */}
            <AirlineOffers />

          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchFlight2;